import { render, staticRenderFns } from "./CampaignData.vue?vue&type=template&id=712423a0&scoped=true"
import script from "./CampaignData.vue?vue&type=script&lang=ts"
export * from "./CampaignData.vue?vue&type=script&lang=ts"
import style0 from "./CampaignData.vue?vue&type=style&index=0&id=712423a0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712423a0",
  null
  
)

export default component.exports